import React from "react";

const launchStages = [
  {
    badge: "Live first",
    date: "12 April",
    cities: ["Cardiff", "Newport", "Swansea"],
  },
  {
    badge: "Next launch",
    date: "12 May",
    cities: ["London", "Bristol", "Birmingham"],
  },
  {
    badge: "Coming next",
    date: "12 June",
    cities: ["Manchester", "Liverpool", "Leeds"],
  },
  {
    badge: "More cities monthly",
    date: "12 July",
    cities: ["Newcastle", "Edinburgh", "Glasgow"],
  },
];

export default function LaunchScheduleCards() {
  return (
    <section className="w-full py-8">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mb-5">
          <h2 className="text-xl sm:text-2xl font-extrabold tracking-tight text-gray-900">
            Launch Schedule (Cities Going Live)
          </h2>

          <p className="mt-2 text-sm sm:text-base text-gray-700">
            We're rolling out in groups of <span className="font-semibold text-gray-900">3 cities at a time</span> to make sure providers get steady job flow from day one.
          </p>

          <p className="mt-1 text-sm text-gray-600">
            <span className="font-semibold text-gray-900">More cities are added every month</span> until Taskbudy covers the whole UK.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
          {launchStages.map((s, idx) => (
            <article
              key={idx}
              className="rounded-2xl border border-orange-100 p-4 shadow-sm bg-white hover:shadow-md transition-shadow"
            >
              <div className="flex items-start justify-between gap-3 mb-3">
                <span className="inline-flex items-center rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-bold tracking-tight text-orange-700 whitespace-nowrap">
                  {s.badge}
                </span>

                <p className="text-xs text-gray-600 text-right leading-tight">
                  Going Live: <span className="font-extrabold text-gray-900">{s.date}</span>
                </p>
              </div>

              <p className="text-sm font-extrabold text-gray-900 tracking-tight">
                {s.cities.join(" • ")}
              </p>

              <div className="mt-3 h-px w-full bg-gray-200" />

              <p className="mt-3 text-xs text-gray-600">
                Apply now to secure your trade &amp; location.
              </p>
            </article>
          ))}
        </div>

        <div className="mt-4">
          <p className="text-sm text-gray-700">
            <span className="font-extrabold text-gray-900">Apply early</span> to secure your trade and location — limited spaces per city.
          </p>
        </div>
      </div>
    </section>
  );
}
